import React from 'react';
import { Facebook, Twitter, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';
import { companyInfo } from '../mock';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://i.postimg.cc/cCHSQ1GD/kiana-Photoroom.png" 
                alt="Company Logo" 
                className="h-12 w-auto object-contain"
              />
              <h3 className="text-2xl font-bold text-amber-400">
                {companyInfo.name}
              </h3>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              {companyInfo.tagline}
            </p>
            <div className="flex space-x-4">
              <a href={companyInfo.social.facebook} className="w-10 h-10 rounded-full bg-white/10 hover:bg-amber-600 flex items-center justify-center transition-all duration-300 hover:scale-110">
                <Facebook size={20} />
              </a>
              <a href={companyInfo.social.twitter} className="w-10 h-10 rounded-full bg-white/10 hover:bg-amber-600 flex items-center justify-center transition-all duration-300 hover:scale-110">
                <Twitter size={20} />
              </a>
              <a href={companyInfo.social.instagram} className="w-10 h-10 rounded-full bg-white/10 hover:bg-amber-600 flex items-center justify-center transition-all duration-300 hover:scale-110">
                <Instagram size={20} />
              </a>
              <a href={companyInfo.social.linkedin} className="w-10 h-10 rounded-full bg-white/10 hover:bg-amber-600 flex items-center justify-center transition-all duration-300 hover:scale-110">
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-amber-400">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('home')} className="text-gray-400 hover:text-amber-400 transition-colors">
                  Home
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')} className="text-gray-400 hover:text-amber-400 transition-colors">
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('projects')} className="text-gray-400 hover:text-amber-400 transition-colors">
                  Our Projects
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('testimonials')} className="text-gray-400 hover:text-amber-400 transition-colors">
                  Testimonials
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-gray-400 hover:text-amber-400 transition-colors">
                  Contact Us
                </button>
              </li>
              <li>
                <a href="/careers" className="text-gray-400 hover:text-amber-400 transition-colors">
                  Careers
                </a>
              </li>
            </ul>
          </div>

          {/* Projects Status */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-amber-400">Project Status</h4>
            <ul className="space-y-3">
              <li className="text-gray-400">Ready to Move</li>
              <li className="text-gray-400">Under Construction</li>
              <li className="text-gray-400">Launching Soon</li>
              <li className="text-gray-400">Investment Options</li>
              <li className="text-gray-400">Resale Properties</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-amber-400">Contact Info</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin size={20} className="text-amber-400 flex-shrink-0 mt-1" />
                {companyInfo.contact.mapLink ? (
                  <a
                    href={companyInfo.contact.mapLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 hover:text-amber-400 text-sm leading-relaxed transition-colors"
                  >
                    {companyInfo.contact.address}
                  </a>
                ) : (
                  <span className="text-gray-400 text-sm leading-relaxed">{companyInfo.contact.address}</span>
                )}
              </li>
              <li>
                <a href={`tel:${companyInfo.contact.phone}`} className="flex items-center space-x-3 text-gray-400 hover:text-amber-400 transition-colors">
                  <Phone size={20} className="text-amber-400" />
                  <span className="text-sm">{companyInfo.contact.phone}</span>
                </a>
              </li>
              <li>
                <a href={`mailto:${companyInfo.contact.email}`} className="flex items-center space-x-3 text-gray-400 hover:text-amber-400 transition-colors">
                  <Mail size={20} className="text-amber-400" />
                  <span className="text-sm">{companyInfo.contact.email}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-12 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} {companyInfo.name}. All rights reserved. | Privacy Policy | Terms & Conditions
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
